<style scoped>

  @media only screen and (max-width: 991px) {
    .ui.button {
      margin-top: 12px !important;
    }
  }

</style>

<template>
  
  <div>                  
    
    <button v-for="(button, index) in buttons" class="ui button" 
      :class="{ 'm-l-10': (index > 0), loading: (performingAction == button.action) }" 
      @click="performAction(button.action)">
      <i :class="button.icon"></i> {{ button.label }}
    </button>

    <complement-request-modal ref="complementRequestModal" :cert="cert" @onConfirm="onConfirmComplementRequest" />
    <complement-finish-modal ref="finishComplementModal" :cert="cert" @onConfirm="onConfirmFinishComplement" />

    <create-pdf-modal ref="createPdfModal" :cert="cert" />

    <yes-no-modal ref="confirmCertFinishModal" title="Finalizar Laudo" 
      :message="`Confirma a finalização do laudo ${cert.id} ?`" @onYes="onConfirmCertFinish" />

  </div>

</template>

<script>
  
  import { AppBrowser, moment } from "@/utils"
  import CertService from "@/services/cert-service"
  import YesNoModal from "@/components/yes-no-modal.vue"
  import ComplementRequestModal from "./complement-request-modal.vue"
  import ComplementFinishModal from "./complement-finish-modal.vue"
  import CreatePdfModal from "./create-pdf-modal.vue"  

  export default {

    name: "CertActionButtons",
    
    props: ["cert"],  

    data() {
      return {
        buttons: [],
        performingAction: null,
        service: new CertService(),
      }
    },

    components: {
      ComplementRequestModal,
      ComplementFinishModal,
      CreatePdfModal,
      YesNoModal,
    },

    mounted() {
      this.loadButtons()
    },

    methods: {

      loadButtons() {

        const status = this.cert.status 
        const complementRequest = this.cert.complementRequest
        const isComplementResponsible = (complementRequest && complementRequest.responsibleId == this.$store.state.auth.user.id)
        const isComplementRequester = (complementRequest && complementRequest.requesterId == this.$store.state.auth.user.id)

        this.buttons = []

        if (!this.$isSimavet()) {

          if (status == "finished") {
            this.buttons.push({ 
              action: "create_pdf",
              icon: "file pdf outline red icon", 
              label: "Visualizar em PDF", 
            })
          }

          return
        }

        if (status == "maintenance") {
          this.buttons.push({ 
            action: "request_complement",
            icon: "tasks orange icon", 
            label: "Solicitar Complemento", 
          })
        }  

        if (status == "waiting_complement" && isComplementResponsible) {
          this.buttons.push({ 
            action: "start_complement",
            icon: "play circle outline teal icon", 
            label: "Iniciar Complemento", 
          })
        }

        if (status == "complement_in_progress" && isComplementResponsible) {
          this.buttons.push({ 
            action: "finish_complement",
            icon: "check double blue icon", 
            label: "Finalizar Complemento", 
          })
        }

        if ( (status != "finished" && !isComplementResponsible) || 
             (status != "finished" && isComplementRequester) ) {
          this.buttons.push({ 
            action: "finish_cert",
            icon: "check circle green icon", 
            label: "Finalizar Laudo", 
          })
        }

        if (!(status == "waiting_complement" && isComplementResponsible)) {
          this.buttons.push({ 
            action: "update",
            icon: "edit grey icon", 
            label: "Alterar", 
          })
        }

        this.buttons.push({ 
          action: "create_pdf",
          icon: "file pdf outline red icon", 
          label: "Gerar PDF", 
        })

        this.buttons.push({ 
          action: "financial",
          icon: "file invoice dollar teal icon", 
          label: "Financeiro", 
        })
      },

      performAction(action) {

        if (this.performingAction == action)
          return

        this.performingAction = action

        if (action == "request_complement") {

          this.requestComplement()            
        
        } else if (action == "start_complement") {
          
          this.startComplement()

        } else if (action == "finish_complement") {
          
          this.finishComplement()

        } else if (action == "finish_cert") {

          this.finishCert()
        
        } else if (action == "update") {

          this.update()
        
        } else if (action == "create_pdf") {

          this.createPdf()

        } else if (action == "financial") {

          this.$router.push(`/procs/certs/${this.cert.id}/financial`)
        }
      },

      requestComplement() {

        this.performingAction = null
        
        this.$refs.complementRequestModal.show()      
      },

      async onConfirmComplementRequest(request) {

        this.performingAction = "request_complement"

        try {

          await this.service.requestComplement(this.cert.id, request)

          this.$reloadDataTables(["cert-complement-requests", "certs", "daily-certs"])

          this.$emit("onActionPerformed")

          this.$msg.success("Solicitação criada com sucesso")
          
        } catch (error) {
          
          this.$errorHandler(error)
        
        } finally {

          this.performingAction = null
        }
      },

      async startComplement() {
        
        try {

          await this.service.startComplement(this.cert.id)

          this.$reloadDataTables(["cert-complement-requests", "certs", "daily-certs"])

          this.$emit("onActionPerformed")
          
        } catch (error) {
          
          this.$errorHandler(error)
        
        } finally {

          this.performingAction = null
        }
      },

      finishComplement() {

        this.performingAction = null
        
        this.$refs.finishComplementModal.show()      
      },

      async onConfirmFinishComplement(comments) {

        this.performingAction = "finish_complement"
        
        try {

          await this.service.finishComplement(this.cert.id, comments)

          this.$reloadDataTables(["cert-complement-requests", "certs", "daily-certs"])

          this.$emit("onActionPerformed")
          
        } catch (error) {
          
          this.$errorHandler(error)
        
        } finally {

          this.performingAction = null
        }
      },

      finishCert() {

        this.performingAction = null

        this.$refs.confirmCertFinishModal.show()
      },

      async onConfirmCertFinish() {

        try {

          await this.service.finishCert(this.cert.id)

          this.$reloadDataTables(["cert-complement-requests", "exam-requests", "certs", "daily-certs"])

          this.$emit("onActionPerformed")

          this.$msg.success("Laudo finalizado com sucesso")
          
        } catch (error) {
          
          this.$errorHandler(error)
        
        } finally {

          this.performingAction = null
        }
      },

      update() {
        this.$router.push(`/procs/certs/${this.cert.id}/form`)
      },

      createPdf() {        

        if (this.$isSimavet()) {
          
          this.performingAction = null
          this.$refs.createPdfModal.show()

        } else {

          this.showPdf()
        }        
      },

      async showPdf() {

        try {

          const authToken = await this.$store.state.auth.fbUser.getIdToken(true)
          const layout = this.cert.customer.logo ? "customer" : "default"
          const date = moment().format("YYYY-MM-DD")
          const time = moment().format("HH:mm")

          let url = `${process.env.VUE_APP_API_URL }/certs/${this.cert.id}/pdf`

          url += `?authToken=${authToken}&layout=${layout}`
          url += `&dateTime=${date}T${time}`

          AppBrowser.openNewTab(url, `laudo_${this.cert.id}.pdf`)
          
        } catch (error) {
          
          this.$errorHandler(error)
        
        } finally {

          this.performingAction = null
        }
      },
    },
  }

</script>